<template>
  <div>
    <el-row style="text-align: left;margin-top: 20px">
      <div style="font-size: 30px;font-weight: bold">{{title}}</div>
    </el-row>
    <el-row>
      <hr size=1 style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 50px"/>
    </el-row>
    <el-row style="margin-top: 20px">
      <iframe :src="iframe_url" frameborder="0" style="width: 100%;height: 900px;" ></iframe>
    </el-row>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        title:'PDF预览',
        iframe_url:''
      }
    },
    mounted(){
      document.querySelector('body').setAttribute('style', 'background-image:url()');
      this.title = decodeURI(this.$route.query.title);
      this.iframe_url= '/static/web/viewer.html?file=/upload'+this.$route.query.path;
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/common/preview/previewPDF.vue